import { render, staticRenderFns } from "./StatsAccountBalance.vue?vue&type=template&id=dd09330a&"
import script from "./StatsAccountBalance.vue?vue&type=script&lang=js&"
export * from "./StatsAccountBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports